import { t as e } from "../../chunks/index.es.CfT5btWg.js";
import { Editor as t, Element as n, Range as r, Transforms as i } from "slate";
//#region lib/Link/lib/actionHandler.ts
var a = (a) => {
	let { editor: o, type: s } = a, { selection: c } = o;
	if (!c) return;
	let l = Array.from(t.nodes(o, {
		at: t.unhangRange(o, c),
		match: (n) => !t.isEditor(n) && e.isInline(n) && e.isOfType(n, s)
	}));
	if (l.length) {
		let e = l[0][0];
		n.isElement(e) && typeof e?.id == "string" && (a.event?.preventDefault(), a.event?.stopPropagation(), document.getElementById(e.id)?.focus());
		return;
	}
	if (r.isCollapsed(c)) return;
	let u = crypto.randomUUID(), d = {
		class: "inline",
		type: s,
		id: u,
		properties: {
			url: "",
			title: "",
			target: ""
		},
		children: [{ text: "" }]
	};
	a.event?.preventDefault(), a.event?.stopPropagation(), t.withoutNormalizing(o, () => {
		i.wrapNodes(o, d, { split: !0 });
	}), setTimeout(() => {
		document.getElementById(u)?.focus();
	}, 0);
};
//#endregion
export { a as actionHandler };
